module.exports = __webpack_public_path__ + "d63baa3c5438dda0cda3cafc1a61b4cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/thrift_savings_plan.png
// module id = 2063
// module chunks = 0